import React from 'react';

import S from 'constants/string.const';

export class ServiceItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checked:
        window.document.location.href.indexOf('signup') > 0
          ? false
          : props.stylist.services.filter((s) => s.service_id === props.service.id).length > 0,
    };
  }

  onCheckboxChange = () => {
    const { onCheckboxChange, service } = this.props;
    if (service.id) {
      onCheckboxChange(service.id);
      this.setState({ checked: !this.state.checked });
    } else if (service.service_id) {
      onCheckboxChange(service.service_id);
      this.setState({ checked: !this.state.checked });
    }
  };

  render() {
    const activeColor = this.state.checked ? '#080b0f' : '#b3b3b3'; // grey
    const disabled = window.document.location.href.indexOf('signup') < 0 ? 'disabled' : '';

    let executionPrice = '';
    for (let i = 0; i < this.props.service.role_executions.length; i += 1) {
      if (this.props.service.role_executions[i].service_id === this.props.service.id) {
        if (
          this.props.service.role_executions[i].price &&
          this.props.service.role_executions[i].role_id === this.props.roleId
        ) {
          executionPrice = this.props.service.role_executions[i].price;
          break;
        }
      }
    }

    return (
      <div data-bem="ServiceItem" className="rounded-list-item no-border">
        {this.props.service.id && (
          <div className="checkbox-list-custom-wrap">
            <input
              type="checkbox"
              className="checkbox-custom"
              id={`${this.props.service.name}${this.props.service.id}`}
              checked={this.state.checked}
              onChange={this.onCheckboxChange}
              disabled={disabled}
            />
            <label
              className="checkbox-custom-label"
              style={{ color: activeColor }}
              htmlFor={`${this.props.service.name}${this.props.service.id}`}
            >
              {this.props.service.name}
              <div className="checkbox-custom-icon">
                <span className="ic-sml-16px ic_check_white" />
              </div>
            </label>
          </div>
        )}
        {this.props.service.id && (
          <div className="list-item-input">
            <div className="checked-overlay" />
            <div className="input-currency">
              <input
                type="text"
                placeholder="000"
                disabled
                id={`${this.props.service.name}${this.props.service.id}Input`}
                value={S.pound + executionPrice}
                autoComplete="off"
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ServiceItem;
